import Awesomplete from './vendor/awesomplete';

const lisp = (str) => {
    var symbols = { 'ą': 'a', 'č': 'c', 'ę': 'e', 'ė': 'e', 'į': 'i', 'š': 's', 'ų': 'u', 'ū': 'u', 'ž': 'z', 'ā': 'a', 'ē': 'e', 'ģ': 'g', 'ī': 'i', 'ķ': 'k', 'ļ': 'l', 'ņ': 'n', 'õ': 'o', 'ä': 'a', 'ö': 'o', 'ü': 'u'};
    str = str.trim();

    str = str.toLowerCase();

    str = str.replace(/[ąčęėįšųūžāēģīķļņõäöü]/g, (s) => {
        return symbols[s];
    });

    return str;
};

const autocomplete = (str) => {
    const node = document.getElementById(str);
    const arrow = document.querySelector('.js-toggle--' + str);
    const clear = document.querySelector('.js-clear--' + str);

    let isOpen = false;
    let isClosed = false;

    const update = (langID, target, str, hidden) => {
        const type = (target.id === 'search-city') ? 'query' : 'city';

        fetch('/wp-json/api/v1/options?langID=' + langID + '&str=' + str + '&type=' + type)
            .then((t) => t.json())
            .then((data) => {
                if (!data || !data.length) {
                    return;
                }

                const list = data.map((option) => {
                    return { label: option.name + ' (' + option.total + ')', value: option.name };
                });

                target.box.list = list;

                if (hidden) {
                    target.box.evaluate();
                    target.box.close();
                } else {
                    target.focus();
                    target.box.evaluate();
                }
            });
    };

    const updateOptions = (node) => {
        const target = (node.id === 'search-city') ? document.getElementById('search-query') : document.getElementById('search-city');

        if (!target || (target.value && node.value)) {
            return;
        }

        if (!target.value && node.value) {
            update(node.dataset.id, target, node.value, true);
        } else if (!node.value) {
            update(node.dataset.id, node, target.value);

            if (!target.value) {
                update(node.dataset.id, target, target.value, true);
            }
        }
    };

    const toggle = (status, delay = 0) => {
        setTimeout(() => {
            isOpen = status;
        }, delay);

        if (arrow) {
            arrow.classList.toggle('is-open', status);
        }
    };

    if (!node) {
        return;
    }

    const box = new Awesomplete(node, {
        minChars: 0,
        maxItems: 1000,
        sort: false,
        filter: function (text, input) {
            return lisp(text).indexOf(lisp(input)) !== -1;
        }
    });

    node.addEventListener('input', () => {
        if (clear) {
            clear.classList.toggle('u-hidden', !node.value);
        }
        if (arrow) {
            arrow.classList.toggle('u-hidden', !!node.value);
        }
    });

    node.addEventListener('focus', () => {
        if (!isOpen && (box.ul.childNodes.length === 0 || box.ul.hasAttribute('hidden'))) {
            toggle(true);
            box.evaluate();
        } else {
            toggle(false);
            box.close();
            node.blur();
        }
    });

    node.addEventListener('blur', () => {
        const suggestion = (Array.isArray(box.suggestions) && box.suggestions.length === 1) ? box.suggestions[0] : null;

        if (!suggestion) {
            return;
        }

        if (lisp(node.value) === lisp(suggestion.value)) {
            node.value = suggestion.value;
        }
    });

    node.addEventListener('awesomplete-selectcomplete', () => {
        node.blur();

        updateOptions(node);

        if (clear) {
            clear.classList.remove('u-hidden');
        }
        if (arrow) {
            arrow.classList.add('u-hidden');
        }
    });

    node.addEventListener('awesomplete-close', () => {
        toggle(false, 150);
    });

    if (arrow) {
        arrow.addEventListener('click', (e) => {
            if (!isOpen) {
                node.focus();
            } else {
                box.close();
            }
        });
    }

    if (clear) {
        clear.addEventListener('click', () => {
            node.value = '';

            updateOptions(node);

            if (clear) {
                clear.classList.add('u-hidden');
            }
            if (arrow) {
                arrow.classList.remove('u-hidden');
            }
        });
    }

    node.box = box;
};

const setCityAwesomplete = (node, cityID) => {
    if (!node || !cityID) {
        return;
    }

    const nodeBox = new Awesomplete(node, {
        minChars: 0,
        maxItems: 1000,
        sort: false,
        filter: function (text, input) {
            return lisp(text).indexOf(lisp(input)) !== -1;
        },
        replace: function (suggestion) {
            this.input.value = suggestion.label;

            if (cityID) {
                cityID.value = suggestion.value;
            }
        }
    });

    node.addEventListener('focus', () => {
        nodeBox.evaluate();
    });

    node.addEventListener('blur', () => {
        const suggestion = (Array.isArray(nodeBox.suggestions) && nodeBox.suggestions.length === 1) ? nodeBox.suggestions[0] : null;

        if (!suggestion) {
            return;
        }

        if (lisp(node.value) === lisp(suggestion.label)) {
            node.value = suggestion.label;

            if (cityID) {
                cityID.value = suggestion.value;
            }
        }
    });
};

const setCityAwesompletes = () => {
    setCityAwesomplete(document.getElementById('form-city'), document.getElementById('form-city-id'));

    setCityAwesomplete(document.getElementById('recommend-form-city'), document.getElementById('recommend-form-city-id'));
};

const inititateAutocomplete = () => {
    const search = document.getElementById('search');
    const city = document.getElementById('search-city');
    const query = document.getElementById('search-query');

    if (city) {
        autocomplete('search-city');
    }

    if (query) {
        autocomplete('search-query');
    }

    if (search && city && query) {
        search.addEventListener('submit', (e) => {
            if (!city.value && !query.value) {
                city.focus();
                e.preventDefault();
            }
        }, false);
    }

    setCityAwesompletes();
};

export default inititateAutocomplete;
